import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Container as g, DrawerContent as x, DateBox as P, DateBoxLabel as b, Placeholder as I, IconWrapper as u } from "./styles.js";
import { useInputErrorMessages as C } from "../InputErrorMessage/useInputErrorMessages.js";
import { Popover as j } from "../Popover/Popover.js";
import { InlineDatePicker as k } from "../InlineDatePicker/InlineDatePicker/InlineDatePicker.js";
import { Calendar as M } from "../../foundations/icons/Calendar.js";
import { InputErrorMessage as v } from "../InputErrorMessage/InputErrorMessage.js";
import { useLocalisation as B } from "../../utils/hooks/useLocalisation.js";
const A = ({
  name: s,
  value: o,
  disabledDays: l,
  onChange: c,
  error: m,
  inPortal: d = !1,
  positioning: p,
  className: f
}) => {
  const { formatDate: h } = B(), { isInvalid: a, errorMessages: r } = C(m);
  return /* @__PURE__ */ n(g, { className: f, children: [
    /* @__PURE__ */ e(
      j,
      {
        placement: "bottom-start",
        offset: 1,
        inPortal: d,
        positioning: p,
        content: (t) => /* @__PURE__ */ e(x, { children: /* @__PURE__ */ e(
          k,
          {
            disabled: l,
            selected: o,
            onDayClick: (i, D) => {
              D.disabled || (c(i), t(!1));
            }
          }
        ) }),
        children: (t) => /* @__PURE__ */ n(
          P,
          {
            name: s,
            "aria-label": "Select Date",
            opened: t,
            error: a,
            "aria-invalid": a,
            "aria-errormessage": r.length > 0 ? r.map((i) => i.id).join(" ") : void 0,
            children: [
              /* @__PURE__ */ e(b, { children: o ? h(o, "PP") : /* @__PURE__ */ e(I, { children: "Select date..." }) }),
              /* @__PURE__ */ e(u, { children: /* @__PURE__ */ e(M, { size: "17px" }) })
            ]
          }
        )
      }
    ),
    r.length > 0 && /* @__PURE__ */ e(v, { children: r })
  ] });
};
export {
  A as DatePicker
};
//# sourceMappingURL=DatePicker.js.map
